import React, { useEffect, useState } from "react";
import { Modal, Spin, Tooltip, Collapse } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./_WorkflowTarefaModal.less";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import WorkflowTipoTarefaTag from "../../pages/workflows/_WorkflowTipoTarefaTag";
import { UserOutlined } from "@ant-design/icons";
import ActionLink from "../action-link";
import ActionBar from "../action-bar";
import WorkflowTarefaDescricao from "../../pages/workflows/tarefa/_WorkflowTarefaDescricao";
import WorkflowTarefaNome from "../../pages/workflows/tarefa/_WorkflowTarefaNome";
import WorkflowTarefaDataEntrega from "../../pages/workflows/tarefa/_WorkflowTarefaDataEntrega";
import useFormatter from "../../hooks/useFormatter";
import moment from "moment";
import WorkflowTarefaItemCriar from "../../pages/workflows/tarefa/_WorkflowTarefaItemCriar";
import WorkflowTarefaItem from "../../pages/workflows/tarefa/_WorkflowTarefaItem";
import WorkflowTarefaMembroAtalho from "./_WorkflowTarefaMembroAtalho";
import useLoading from "../../hooks/useLoading";
import WorkflowTarefaAnexoCriar from "../../pages/workflows/tarefa/_WorkflowTarefaAnexoCriar";
import WorkflowTarefaAnexo from "../../pages/workflows/tarefa/_WorkflowTarefaAnexo";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import SelectWorkflowEmpresa from "../../pages/workflows/tarefa/_SelectWorkflowEmpresa";
import SelectWorkflowUnidade from "../../pages/workflows/tarefa/_SelectWorkflowUnidade";
import WorkflowTarefaObservacao from "../../pages/workflows/tarefa/_WorkflowTarefaObservacao";
import SelectWorkflowAcesso from "../../pages/workflows/tarefa/_SelectWorkflowAcesso";
import SelectWorkflowModulo from "../../pages/workflows/tarefa/_SelectWorkflowModulo";
import WorkflowTarefaArquivamento from "../../pages/workflows/tarefa/_WorkflowTarefaDataArquivamento";
import WorkflowTarefaDataPrazo from "../../pages/workflows/tarefa/_WorkflowTarefaDataPrazo";
import {
  updateWorkflowTarefaAcesso,
  updateWorkflowTarefaDataEntrega,
  updateWorkflowTarefaDataPrazo,
  updateWorkflowTarefaDescricao,
  updateWorkflowTarefaEmpresa,
  updateWorkflowTarefaNome,
  updateWorkflowTarefaObservacao,
  updateWorkflowTarefaUnidade,
  updateWorkflowTarefaModulo,
  fetchWorkflowTarefa,
  removeWorkflowTarefaMembro,
  selectWorkflowTarefaId,
} from "../../store/workflow";

export default function ModuloTarefaModal(props) {
  const { tarefa, workflow, usuarioId, isClienteOperador, isClienteGestor, onFetchLogs } = props;

  const { t } = useTranslation();
  const { formatDateTime } = useFormatter();
  const dispatch = useDispatchWithResult();
  const loading = useLoading(fetchWorkflowTarefa.typePrefix);
  const [now, setNow] = useState(Date.now());

  const workflowId = workflow.id;
  const { id, nome, descricao, dataPrazo, dataEntrega, modulo, acesso, dataArquivamento, empresa, unidade, observacao, itens, anexos, etapa, tipoTarefa, logs, membros } = tarefa;

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(interval);
  }, []);

  const handleNomeSubmit = async (nome) => {
    await unwrapAxiosPromise(dispatch(updateWorkflowTarefaNome({ workflowId, id, nome })));
    if (props.onUpdate) props.onUpdate();
  };
  const handleDescricaoSubmit = async (descricao) => {
    await unwrapAxiosPromise(dispatch(updateWorkflowTarefaDescricao({ workflowId, id, descricao })));
    if (props.onUpdate) props.onUpdate();
  };
  const handleDataPrazoSubmit = async (dataPrazo) => {
    await unwrapAxiosPromise(dispatch(updateWorkflowTarefaDataPrazo({ workflowId, id, dataPrazo })));
    if (props.onUpdate) props.onUpdate();
  };
  const handleDataEntregaSubmit = async (dataEntrega) => {
    await unwrapAxiosPromise(dispatch(updateWorkflowTarefaDataEntrega({ workflowId, id, dataEntrega })));
    if (props.onUpdate) props.onUpdate();
  };
  const handleModuloSubmit = async (modulo) => {
    await unwrapAxiosPromise(dispatch(updateWorkflowTarefaModulo({ workflowId, id, modulo })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleModuloUnload = async () => {
    await unwrapAxiosPromise(dispatch(fetchWorkflowTarefa({ workflowId, id })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleAcessoSubmit = async (acessoId) => {
    await unwrapAxiosPromise(dispatch(updateWorkflowTarefaAcesso({ workflowId, id, acessoId })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleAcessoUnload = async () => {
    await unwrapAxiosPromise(dispatch(fetchWorkflowTarefa({ workflowId, id })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleEmpresaSubmit = async (empresaId) => {
    await unwrapAxiosPromise(dispatch(updateWorkflowTarefaEmpresa({ workflowId, id, empresaId })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleEmpresaUnload = async () => {
    await unwrapAxiosPromise(dispatch(fetchWorkflowTarefa({ workflowId, id })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleUnidadeSubmit = async (unidadeId) => {
    await unwrapAxiosPromise(dispatch(updateWorkflowTarefaUnidade({ workflowId, id, unidadeId })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleUnidadeUnload = async () => {
    await unwrapAxiosPromise(dispatch(fetchWorkflowTarefa({ workflowId, id })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleObservacaoSubmit = async (observacao) => {
    await unwrapAxiosPromise(dispatch(updateWorkflowTarefaObservacao({ workflowId, id, observacao })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleMembroRemoveClick = async (membroId) => {
    await unwrapAxiosPromise(dispatch(removeWorkflowTarefaMembro({ workflowId, id, membroId })));
    if (props.onUpdate) props.onUpdate();
  };

  const handleCancel = () => {
    if (props.onCancel) props.onCancel();
  };

  return (
    <Modal
      title={
        <div className={styles["titulo"]}>
          <div>
            <WorkflowTarefaNome nome={nome} onSubmit={handleNomeSubmit} readOnly={!isClienteOperador || dataArquivamento} />
            <div>({etapa?.nome})</div>
          </div>
          <div>
            <WorkflowTipoTarefaTag {...tipoTarefa} />
          </div>
        </div>
      }
      open={true}
      destroyOnClose
      footer={false}
      onCancel={handleCancel}
    >
      <Spin spinning={loading}>
        <div className={styles["workflow-tarefa-modal"]}>
          <div className={styles["cabecalho"]}>{t("Descrição")}</div>
          <WorkflowTarefaDescricao descricao={descricao} onSubmit={handleDescricaoSubmit} readOnly={!isClienteOperador || dataArquivamento} />

          <div className={styles["datas"]}>
            <div>
              <div className={styles["cabecalho"]}>{t("Prazo")}</div>
              <WorkflowTarefaDataPrazo dataPrazo={dataPrazo} onSubmit={handleDataPrazoSubmit} readOnly={!isClienteOperador || dataArquivamento} />
            </div>
            <div>
              <div className={styles["cabecalho"]}>{t("Entrega")}</div>
              <WorkflowTarefaDataEntrega dataEntrega={dataEntrega} onSubmit={handleDataEntregaSubmit} readOnly={!isClienteOperador || dataArquivamento} />
            </div>
            {dataArquivamento && (
              <div>
                <div className={styles["cabecalho"]}>{t("Data Arquivamento")}</div>
                <WorkflowTarefaArquivamento dataArquivamento={dataArquivamento} />
              </div>
            )}
          </div>

          <div className={styles["cabecalho"]}>{t("Módulo")}</div>
          <SelectWorkflowModulo workflowId={workflowId} modulo={modulo} onSubmit={handleModuloSubmit} onUnload={handleModuloUnload} readOnly={!isClienteOperador || dataArquivamento} />

          {!!modulo && (
            <>
              <div className={styles["cabecalho"]}>{t("Acesso")}</div>
              <SelectWorkflowAcesso workflowId={workflowId} acesso={acesso} onSubmit={handleAcessoSubmit} onUnload={handleAcessoUnload} readOnly={!isClienteOperador || dataArquivamento} />
            </>
          )}

          {!!acesso && (
            <>
              <div className={styles["cabecalho"]}>{t("Empresa")}</div>
              <SelectWorkflowEmpresa workflowId={workflowId} acessoId={acesso?.id} empresa={empresa} onSubmit={handleEmpresaSubmit} onUnload={handleEmpresaUnload} readOnly={!isClienteOperador || dataArquivamento} />
            </>
          )}

          {!!empresa && (
            <>
              <div className={styles["cabecalho"]}>{t("Unidade")}</div>
              <SelectWorkflowUnidade workflowId={workflowId} acessoId={acesso?.id} empresaId={empresa?.id} unidade={unidade} onSubmit={handleUnidadeSubmit} onUnload={handleUnidadeUnload} readOnly={!isClienteOperador || dataArquivamento} />
            </>
          )}

          <div className={styles["cabecalho"]}>{t("Membros")}</div>
          <div className={styles["conteudo"]}>
            {membros?.map((membro) => (
              <div key={membro.id} className={styles["item"]}>
                <UserOutlined />
                <div>{membro.nome}</div>
                {(isClienteOperador || dataArquivamento || (isClienteOperador && membro.id !== usuarioId)) && (
                  <ActionBar>
                    <ActionLink.Remove noTitle onClick={() => handleMembroRemoveClick(membro.id)} />
                  </ActionBar>
                )}
              </div>
            ))}
            {isClienteOperador && !dataArquivamento && <WorkflowTarefaMembroAtalho tarefaId={id} workflowId={workflowId} onUpdate={props.onUpdate} />}
          </div>

          <div className={styles["cabecalho"]}>{t("Observação")}</div>
          <WorkflowTarefaObservacao observacao={observacao} onSubmit={handleObservacaoSubmit} readOnly={!isClienteOperador || dataArquivamento} />

          <div className={styles["cabecalho"]}>{t("Anexos")}</div>
          <div className={styles["conteudo"]}>
            {anexos?.map((anexo) => (
              <WorkflowTarefaAnexo key={anexo.id} {...anexo} tarefa={id} workflowId={workflowId} onUpdate={props.onUpdate} />
            ))}
            {isClienteOperador && !dataArquivamento && <WorkflowTarefaAnexoCriar tarefaId={id} workflowId={workflowId} onUpdate={props.onUpdate} />}
          </div>

          <div className={styles["cabecalho"]}>{t("Itens")}</div>
          <div className={styles["conteudo"]}>
            {itens?.map((item) => (
              <WorkflowTarefaItem key={item.id} {...item} workflowId={workflowId} tarefa={id} onUpdate={props.onUpdate} />
            ))}
            {isClienteOperador && !dataArquivamento && <WorkflowTarefaItemCriar tarefaId={id} readOnly={!isClienteOperador || dataArquivamento} workflowId={workflowId} onUpdate={props.onUpdate} />}
          </div>

          <Collapse
            bordered={true}
            defaultActiveKey={[]}
            onChange={(activeKeys) => {
              if (onFetchLogs) {
                onFetchLogs();
              }
            }}
          >
            <Collapse.Panel header={t("Logs")} key="1">
              <div className={styles["logs"]}>
                {logs?.map((log) => (
                  <div key={log.id}>
                    <div>{log.texto}</div>
                    <div className={styles["log-autor"]}>
                      <Tooltip title={formatDateTime(log.createdAt)}>{moment(log.createdAt).fromNow()}</Tooltip>
                      <div>
                        {t("por")} <strong>{log.usuario.nome}</strong>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Collapse.Panel>
          </Collapse>
        </div>
      </Spin>
    </Modal>
  );
}
